import React from 'react';
import AdminConfiguration from '../../components/admin/components/AdminConfiguration';

const Configuration = () => {
    return <AdminConfiguration />;
};

export default Configuration;
